/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { STATIC_QUALITY_NOTES } from '../constants';
import { formatMonthLabel, orDash } from '../utils/format';
import {
   Card,
   CardHead,
   CardTitle,
   Pill,
   QualityNotes,
   QualityPills,
} from '../styles';
import { GhostButton } from '../../../../styles/ui/Button';

// ---------------------------------------------------------------------------
// [A] Painel de qualidade dos dados.
//
// Regra do handoff (0084 §5.6): `data_quality` vem em TODO payload e PRECISA
// ser alcançável na UI. Os números têm ressalvas reais — 71% da base não tem
// origem, cancelamento não tem data, DSO mede do boleto e não da venda — e um
// operador que não alcança essas notas lê o painel errado com toda a confiança.
//
// Exibe as `notes` da API (o que a coleta ressalva) seguidas das notas fixas da
// tela (o que o MODELO não tem). São origens distintas, mesma lista para quem lê.
// ---------------------------------------------------------------------------

export default function DataQualityPanel({ dataQuality, onClose }) {
   const emissionField = dataQuality?.emission_date_field;
   const historicalUntil = dataQuality?.historical_load_until;
   const futureNull = dataQuality?.future_points_are_null;
   const apiNotes = Array.isArray(dataQuality?.notes) ? dataQuality.notes : [];

   return (
      <Card as="aside" aria-label="Qualidade dos dados">
         <CardHead>
            <CardTitle>Qualidade dos dados</CardTitle>
            <GhostButton type="button" onClick={onClose}>
               Fechar
            </GhostButton>
         </CardHead>

         <QualityPills>
            <Pill>Data de emissão: {orDash(emissionField)}</Pill>
            {historicalUntil ? (
               <Pill>Carga histórica até {formatMonthLabel(historicalUntil)}</Pill>
            ) : null}
            {futureNull ? <Pill>Pontos futuros de safra = null</Pill> : null}
         </QualityPills>

         <QualityNotes>
            {apiNotes.map((note) => (
               <li key={note}>{note}</li>
            ))}
            {STATIC_QUALITY_NOTES.map((note) => (
               <li key={note}>{note}</li>
            ))}
         </QualityNotes>
      </Card>
   );
}

DataQualityPanel.propTypes = {
   dataQuality: PropTypes.shape({
      emission_date_field: PropTypes.string,
      historical_load_until: PropTypes.string,
      future_points_are_null: PropTypes.bool,
      notes: PropTypes.arrayOf(PropTypes.string),
   }),
   onClose: PropTypes.func.isRequired,
};
